/* Publish by EComposer at 2026-10-23 02:55:47*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wx27nyiiarp"]=  window.__ectimmers["ecom-wx27nyiiarp"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-wx27nyiiarp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wx27nyiiarp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-74bn89usmfn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-74bn89usmfn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mgjekbg4m1k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mgjekbg4m1k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s0t7igdfoig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s0t7igdfoig', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c49nmiy8upc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c49nmiy8upc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jy9akdvd9t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jy9akdvd9t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8z5vvjwwong').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8z5vvjwwong', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exqwizf21da').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exqwizf21da', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-juacz1pldo9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-juacz1pldo9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-480q95ktzgw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-480q95ktzgw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-icnbri3mpbn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-icnbri3mpbn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-osuq58u3h3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-osuq58u3h3d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tsbgbde3v8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tsbgbde3v8r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7wxm3z45l8o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7wxm3z45l8o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3d8ab2rqypa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3d8ab2rqypa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-86vbokpr70o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-86vbokpr70o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qgact39p8i9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qgact39p8i9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ejplccdrejp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ejplccdrejp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qvbvalabzu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvbvalabzu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tr7qhcmm298').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tr7qhcmm298', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t9tmx1qwzzg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t9tmx1qwzzg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-awuy4vjifov').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-awuy4vjifov', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rrvc0rh501').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rrvc0rh501', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1c07ghflr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1c07ghflr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ow1snr2ak2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ow1snr2ak2c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cvfwf3b3ym6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cvfwf3b3ym6', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-d5rca48z6q"]=  window.__ectimmers["ecom-d5rca48z6q"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-d5rca48z6q"]["75exnnaq3"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-d5rca48z6q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d5rca48z6q', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtxgh1a12jd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtxgh1a12jd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-421uuped1op').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-421uuped1op', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-1pewk1xm8mr"]=  window.__ectimmers["ecom-1pewk1xm8mr"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-1pewk1xm8mr"]["7n9yuxvwn"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-1pewk1xm8mr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1pewk1xm8mr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vwx6jltt6qs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vwx6jltt6qs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ppo414lpp4k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ppo414lpp4k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xnk3aql4ow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xnk3aql4ow', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-db3nsmu2ri4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-db3nsmu2ri4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ip1gnct6ow').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ip1gnct6ow', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qgoydvhv1gj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qgoydvhv1gj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0f2sgpum5o0o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0f2sgpum5o0o', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rs1z2me6yy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rs1z2me6yy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ilk0ht2vub').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ilk0ht2vub', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}